/**
 * 文本输入
 */
import React from 'react';
import { Input } from 'antd';
import cls from 'classnames';
import { TextAreaProps } from 'antd/lib/input/TextArea';

import styles from './index.module.scss';

interface IProps
  extends Pick<TextAreaProps, Exclude<keyof TextAreaProps, 'onChange' | 'showCount'>> {
  onChange?: (val: string) => void;
}

const Index: React.FC<IProps> = (props) => {
  const { className, onChange, disabled } = props;
  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <Input.TextArea
      {...props}
      onChange={handleChange}
      showCount
      className={cls(styles.textAreaInput, disabled ? styles.disabledInput : null, className)}
    />
  );
};

export default Index;
